module.exports = __webpack_public_path__ + "img/album06_03.99b9f9fd.jpg";